<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-11",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 52,
      nextPage: '/questionnaire/section4',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'cardBtn',
          mobile: 'cardBtn'
        },
        mainTitle: 'What is your current work status?',
        btn: [
          [
            {
              text: 'Sedentary, long hours at the computer',
              clickedIcon: require('@/assets/icon/clickedIcon/57-1.png'),
              icon: require('@/assets/icon/questionIcon/57-1.png')
            },{
              text: 'Standing for a long time',
              clickedIcon: require('@/assets/icon/clickedIcon/57-2.png'),
              icon: require('@/assets/icon/questionIcon/51-2.png')
            }
          ],[
            {
              text: 'Walking more than half the time',
              clickedIcon: require('@/assets/icon/clickedIcon/57-3.png'),
              icon: require('@/assets/icon/questionIcon/51-3.png')
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
